import Choices from 'choices.js';
import HystModal from 'hystmodal';
import { isValidMail } from '../../../../../../../Common/Resources/src_front/js/helper-functions/isValidMail';

export const initRegistrationForm = () => {
    // VARS
    const registrationFormWrap = document.querySelector('[data-registration-form-wrap]');
    if (!registrationFormWrap) return;
    const registrationForm = registrationFormWrap.querySelector('[data-registration-form]');
    const btnsNextStep = registrationFormWrap.querySelectorAll('[data-form-next-step-btn]');
    const btnsPrevStep = registrationFormWrap.querySelectorAll('[data-form-prev-step-btn]');
    const selects = registrationFormWrap.querySelectorAll('[data-custom-select]');
    const selectQuickContact = registrationFormWrap.querySelector('[data-custom-select="quick-contact"]');
    const inputs = registrationFormWrap.querySelectorAll('[data-input]');
    const checkboxAccept = registrationFormWrap.querySelector('[data-input="accept"]');
    const submit = registrationFormWrap.querySelector('[data-form-submit]');
    const stepCounter = registrationFormWrap.querySelector('[data-step-counter]');
    const stepProgressBar = registrationFormWrap.querySelector('[data-step-progress-bar]');
    const activeClass = '--active';
    const errorClass = '--error';
    const visibleClass = '--visible';
    const hiddenClass = '--hidden';
    let currentStep = 1;
    const stepProgressBarWidths = [-66.66, -33.33, 0];
    const typesNickname = ['Skype', 'Telegram', 'WhatsApp'];
    const modal = new HystModal({
        catchFocus: false,
    });
    const choices = [];

    // INITS
    stepProgressBar.style.transform = `translateX(${stepProgressBarWidths[currentStep - 1]}%)`;

    selects.forEach((select) => {
        const placeholderValue = select.querySelector('option[disabled]').textContent;

        const choice = new Choices(select, {
            searchEnabled: false,
            itemSelectText: '',
            placeholder: true,
            placeholderValue,
            shouldSort: false,
        });

        choices.push(choice);
    });

    // LISTENERS
    registrationForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        const isValid = validateThirdStep();

        try {
            grecaptcha.ready(function () {
                grecaptcha.execute(window.grecaptchaKey, { action: 'submit' }).then(function (token) {
                    const recaptchaInput = registrationForm.querySelector('[data-recaptcha-token]');
                    recaptchaInput.value = token;

                    if (isValid) {
                        fetchForm();
                    }
                });
            });
        } catch (error) {
            console.error(error);
        }
    });

    inputs.forEach((input) => {
        input.addEventListener('focus', hideError);
    });

    selects.forEach((select) => {
        select.addEventListener('change', hideError);
    });

    selectQuickContact.addEventListener('change', handleOnChangeQuickContact);

    checkboxAccept.addEventListener('change', function () {
        submit.disabled = !this.checked;
    });

    btnsNextStep.forEach((btnNextStep) => {
        btnNextStep.addEventListener('click', handleOnClickNextStep);
    });

    btnsPrevStep.forEach((btnPrevStep) => {
        btnPrevStep.addEventListener('click', handleOnClickPrevStep);
    });

    // HANDLERS
    function handleOnClickNextStep() {
        const index = +this.closest('[data-form-step]').getAttribute('data-form-step');
        let isValid;

        if (index === 1) {
            isValid = validateFirstStep();
        } else if (index === 2) {
            isValid = validateSecondStep();
        }

        if (isValid) {
            goToStep(currentStep + 1);
        }
    }

    function handleOnClickPrevStep() {
        goToStep(currentStep - 1);
    }

    function handleOnChangeQuickContact() {
        const step = registrationFormWrap.querySelector('[data-form-step="3"]');
        const email = step.querySelector('[data-input="quick-contact-email"]');
        const emailWrap = email.closest('[data-condition-field]');
        const emailFirstStep = registrationFormWrap.querySelector('[data-input="email"]');
        const nickname = step.querySelector('[data-input="quick-contact-nickname"]').closest('[data-condition-field]');
        const type = this.value;

        email.value = emailFirstStep.value.trim();

        if (typesNickname.includes(type)) {
            emailWrap.classList.add(hiddenClass);
            nickname.classList.remove(hiddenClass);
        } else {
            emailWrap.classList.remove(hiddenClass);
            nickname.classList.add(hiddenClass);
        }
    }

    // FUNCTIONS
    function validateFirstStep() {
        let isValid = true;
        const step = registrationFormWrap.querySelector('[data-form-step="1"]');
        const inputs = step.querySelectorAll('[data-input]');

        inputs.forEach((input) => {
            const inputType = input.getAttribute('data-input');

            if (inputType === 'email') {
                if (!isValidMail(input.value.trim())) {
                    isValid = false;
                    showError(input);
                }
            } else if (inputType === 'password') {
                if (input.value.length < 4 || input.value.length > 16) {
                    isValid = false;
                    showError(input);
                }
            } else if (inputType === 'confirm-password') {
                const password = registrationFormWrap.querySelector('[data-input="password"]');

                if (input.value.trim() !== password.value.trim()) {
                    isValid = false;
                    showError(input);
                }
            } else {
                if (!input.value.trim()) {
                    isValid = false;
                    showError(input);
                }
            }
        });

        return isValid;
    }

    function validateSecondStep() {
        let isValid = true;
        const step = registrationFormWrap.querySelector('[data-form-step="2"]');
        const inputs = step.querySelectorAll('[data-input]');

        inputs.forEach((input) => {
            const inputType = input.getAttribute('data-input');

            if (inputType === 'url-traffic-source') {
                if (!isValidUrl(input.value.trim())) {
                    isValid = false;
                    showError(input);
                }
            } else {
                if (!input.value.trim()) {
                    isValid = false;
                    showError(input);
                }
            }
        });

        return isValid;
    }

    function validateThirdStep() {
        let isValid = true;
        const step = registrationFormWrap.querySelector('[data-form-step="3"]');
        const selectQuickContact = step.querySelector('[data-custom-select="quick-contact"]');
        const typeQuickContact = selectQuickContact.value.trim();
        const inputs = step.querySelectorAll('[data-input]');

        inputs.forEach((input) => {
            const inputType = input.getAttribute('data-input');

            if (inputType === 'quick-contact-email') {
                if (typeQuickContact === 'Email') {
                    if (!isValidMail(input.value.trim())) {
                        isValid = false;
                        showError(input);
                    }
                }
            } else if (inputType === 'quick-contact-nickname') {
                if (typesNickname.includes(typeQuickContact)) {
                    if (!input.value.trim()) {
                        isValid = false;
                        showError(input);
                    }
                }
            } else {
                if (!input.value.trim()) {
                    isValid = false;
                    showError(input);
                }
            }
        });

        return isValid;
    }

    function goToStep(step) {
        if (step < 1 || step > 3) {
            console.error('Invalid step number');
            return;
        }

        currentStep = step;
        updateUIForStep();
    }

    function updateUIForStep() {
        const nextStepElem = registrationFormWrap.querySelector(`[data-form-step="${currentStep}"]`);
        const currentStepElem = registrationFormWrap.querySelector(`.${activeClass}[data-form-step]`);

        currentStepElem.classList.remove(activeClass);
        nextStepElem.classList.add(activeClass);

        stepCounter.textContent = `${currentStep}`;
        stepProgressBar.style.transform = `translateX(${stepProgressBarWidths[currentStep - 1]}%)`;
    }

    function showError(input, errorText) {
        const name = input.getAttribute('name');
        const error = registrationFormWrap.querySelector(`[data-error-${name}]`);
        const helpText = registrationFormWrap.querySelector(`[data-help-text-${name}]`);

        if (errorText) {
            error.textContent = errorText;
        } else {
            error.textContent = error.getAttribute(`data-error-${name}`);
        }

        error.classList.add(visibleClass);
        helpText?.classList.add(hiddenClass);
        input.classList.add(errorClass);
    }

    function hideError() {
        const name = this.getAttribute('name');
        const error = registrationFormWrap.querySelector(`[data-error-${name}]`);
        const helpText = registrationFormWrap.querySelector(`[data-help-text-${name}]`);

        if (!error) return;

        error.classList.remove(visibleClass);
        helpText?.classList.remove(hiddenClass);
        this.classList.remove(errorClass);
    }

    async function fetchForm() {
        const formData = new FormData(registrationForm);
        const action = registrationForm.getAttribute('action');
        const data = Object.fromEntries(formData.entries());

        const response = await fetch(action, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        const jsonResponse = await response.json();

        if (!jsonResponse.success && !jsonResponse.errors.length) {
            modal.open('[data-registration-error]');
            return;
        }

        if (Boolean(!jsonResponse.success && jsonResponse.errors.length)) {
            jsonResponse.errors.forEach((error) => {
                const input = document.querySelector(`[name="${error.attribute_name?.toLowerCase()}"]`);
                if (!input) {
                    modal.open('[data-registration-error]');
                    return;
                }

                const step = input.closest('[data-form-step]').getAttribute('data-form-step');
                showError(input, error.err_msg);
                goToStep(+step);
            });

            return;
        }

        if (jsonResponse.url) {
            const link = document.querySelector('[data-registration-autologin]');
            link.setAttribute('href', jsonResponse.url);
        }

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ event: 'generate_lead' });
        modal.open('[data-registration-success]');
        resetForm();
    }

    function resetForm() {
        registrationForm.reset();

        selects.forEach((select) => {
            select.value = '';
        });

        choices.forEach((choice) => {
            choice.setChoiceByValue('');
        });
    }

    function isValidUrl(url) {
        const pattern = new RegExp(
            '^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$',
            'i',
        ); // fragment locator
        return !!pattern.test(url);
    }
};
